import {
  decodeReplayControls,
  validateReplayEnvelope,
  type ReplayEnvelopeV1,
  type ResolvedCarControls,
} from '@cars/shared';

export class ReplayInputSource {
  private readonly replay: ReplayEnvelopeV1;
  private eventIndex = 0;
  private controls: ResolvedCarControls = { throttle: 0, brake: 0, steering: 0 };

  constructor(replay: ReplayEnvelopeV1) {
    validateReplayEnvelope(replay);
    this.replay = replay;
  }

  controlsAt(tick: number): ResolvedCarControls {
    while (
      this.eventIndex < this.replay.events.length &&
      this.replay.events[this.eventIndex].tick <= tick
    ) {
      this.controls = decodeReplayControls(this.replay.events[this.eventIndex].controls);
      this.eventIndex += 1;
    }
    return { ...this.controls };
  }

  reset(): void {
    this.eventIndex = 0;
    this.controls = { throttle: 0, brake: 0, steering: 0 };
  }

  seek(tick: number): void {
    this.reset();
    while (
      this.eventIndex < this.replay.events.length &&
      this.replay.events[this.eventIndex].tick <= tick
    ) {
      this.controls = decodeReplayControls(this.replay.events[this.eventIndex].controls);
      this.eventIndex += 1;
    }
  }
}
